import { createSelector } from 'reselect';

// Types
import { GiftCardVoucherProps } from 'types/GiftCardVoucher.types';
import { RootState } from 'types/RootState.types';

// Config
import paymentTypeConstants from '@constants/paymentTypeConstants';
import isZeroAmount from '@utils/payment/isZeroAmount';

export const getGiftCardApplyGiftPaymentFailedSelector = (state: RootState) =>
  state.giftCard?.applyGiftPaymentFailed ?? false;
export const getGiftCardErrorMessageSelector = (state: RootState) => state.giftCard?.errorMessage;
export const getGiftCardFormSubmitFailedSelector = (state: RootState) => state.giftCard?.formSubmitFailed ?? false;
export const getGiftCardIsLoadingSelector = (state: RootState) => state.giftCard?.isLoading ?? false;

const EMPTY_ARRAY: any[] = [];
const getPaymentsSelector = (state: RootState) => state.orderForm?.payments ?? EMPTY_ARRAY;

export const giftCardsSelector = createSelector(
  [getPaymentsSelector, (_: RootState, context: string | undefined) => context],
  (payments, context) => {
    const usedGiftCards: GiftCardVoucherProps[] = [];
    const unusedGiftCards: GiftCardVoucherProps[] = [];

    payments
      .filter((payment) => payment.type === paymentTypeConstants.GIFT_CARD)
      .filter((payment) => !payment.isRemoved || (payment.isRemoved && payment.removalContext === context))
      .forEach((payment) => {
        if (isZeroAmount(payment.amount)) {
          unusedGiftCards.push({
            ...payment.details,
            id: payment.id,
          });
        } else {
          usedGiftCards.push({
            ...payment,
            cardNumber: payment.details?.cardNumber,
            pin: payment.details?.pin,
          });
        }
      });

    return { usedGiftCards, unusedGiftCards };
  },
);
